export default function parseData(date: string | Date, datetime: boolean = true) {
  const created = new Date(date)
  const year = created.getUTCFullYear()
  const month = created.getUTCMonth() + 1
  const day = created.getUTCDate()
  const hour = created.getHours()
  const minutes = created.getMinutes()

  const currentDate = `${day < 10 ? `0${day}` : day}/${month < 10 ? `0${month}` : month}/${year}`
  const currentTime = `${hour < 10 ? `0${hour}` : hour}:${minutes < 10 ? `0${minutes}` : minutes}`

  return datetime ? `${currentDate} ${currentTime}` : currentDate
}
